import React from 'react'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/order.css'

export default function OrderComplete(props) {
  return (
    <div className='order_page'>
      <PageTransition />
      {
        props.orderCompleteMessage?
        <LinksMap linksArr={[{name: 'Home', path:'/', active: false}, {name: 'Cart', path:'/cart', active: false}, {name: 'Checkout', path: '/checkout', active: false}, {name: 'Order Complete', path: '/order-complete', active: true}]} pageName="Order Complete" />
        : 
        <LinksMap linksArr={[{name: 'Home', path:'/', active: false}, {name: 'My Account', path: '/my-account', active: false}, {name: 'Order', path: '/order', active: true}]} pageName="Order" />
      }

      <div className='container'>
        {
          props.orderCompleteMessage?
          <div className='order_complete_message'><span class='fas fa-check'></span> Thank you. Your order has been received.</div>
          : <></>
        }
        <div className='order_details'>
          <div className='card'>
            <div className='title'>Order Number</div>
            <div className='value'>2605</div>
          </div>
          <div className='card'>
            <div className='title'>Status</div>
            <div className='value color'>PROCESSING</div>
          </div>
          <div className='card'>
            <div className='title'>Date</div>
            <div className='value'>December 21, 2021</div>
          </div>
          <div className='card'>
            <div className='title'>Total</div>
            <div className='value'>{props.currency} 700</div>
          </div>
          <div className='card'>
            <div className='title'>Payment Method</div>
            <div className='value'>#12345</div>
          </div>
        </div>

        <div className='payment_details'>
          <div className='payment_details_header'>
            <div className='title'>Your Order</div>
          </div>
          <div className='products section'>
            <div className='header'>
              <div className='title'>Product</div>
            </div>
            <div className='content'>
              <div className='card'>
                <div className='title'>Battery charger <span className='fas fa-times'></span> <span>03</span></div>
                <div className='price'>$10.00</div>
              </div>
              <div className='subtotal card'>
                <div className='title'>Subtotal</div>
                <div className='price'>$10.00</div>
              </div>
            </div>
          </div>

          <div className='shipping_option section'>
            <div className='header'>
              <div className='title'>Shipping: <span>Local Pickup</span></div>
            </div>
          </div>

          <div className='payment_methods section'>
            <div className='header'>
              <div className='title'>Payment method: <span>Cash On Delivery</span></div>
            </div>
          </div>

          <div className='total_price section'>
            <div className='content'>
              <div className='title'>Total</div>
              <div className='price'>$11.00</div>
            </div>
          </div>
        </div>

        <div className='billing_address'>
          <div className='title'>Billing Adress</div>

          <div className='content'>
            <span>Forhad Hossian</span>
            <span>MangoQuiz</span>
            <span>Patwary Bari, Meghdair, Palakhal, Kachua, Chandpur, Chittagong</span>
            <span>New York, NY 10001</span>
            <span>0234156489541</span>
            <span>forhadhossain60@outlook.com</span>
          </div>
        </div>
      </div>
    </div>
  )
}
